import { getHashParameters } from "./get-hash-parameters";

export const getUrlParameter = (parameterKey: string) => {
  const url = new URL(window.location.href);
  const hashParameters = getHashParameters();

  if (hashParameters.has(parameterKey)) {
    return hashParameters.get(parameterKey);
  }

  const querystring = url.searchParams;

  if (querystring.has(parameterKey)) {
    return querystring.get(parameterKey);
  }

  return null;
};
